module.exports = function(service) {
	'use strict'
	service.factory('aiModalService', aiModalService);
	aiModalService.$inject = ['$http','alertService','serverError','offlineError','refreshtokenService','API_URL'];
	function aiModalService($http,alertService,serverError,offlineError,refreshtokenService,API_URL) {
		function httpMethod(method, httpFragment, callbackSuccess, callbackError, data) {
            var url = API_URL + 'aitools/' + httpFragment;
            var request = method === 'post' || method === 'put' 
                ? $http[method](url, data)
                : $http[method](url);
                
            request.success(function (data, status, headers) {
                if(callbackSuccess) {
                    callbackSuccess(data);
                }
            })
            .error(function (data, status, header, config) {
                if(!window.navigator.onLine) {
                    offlineError()
                    alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                    return
                }
                if(status ==401) {
                    var promise = refreshtokenService.getAccessToken();
                    promise.then(
                        function(answer) {
                            if(answer==200) {   
                                httpMethod(method, httpFragment, callbackSuccess, callbackError,data);
                            }
                        },
                        function(error) {
                            // report something
                        },
                        function(progress) {
                            // report progress
                        });
                }else if(status ==502) {
                    serverError();
                } else { 
                    if(callbackError) {
                        var message = (data && data.message)? data.message:'Failed to load response data.';
                        callbackError(message);
                    }
                }
            })
        };
        return {
			post: function(httpFragment, data, callbackSuccess, callbackError) {
                httpMethod('post', httpFragment, callbackSuccess, callbackError,data);
			},
            put: function(httpFragment, data, callbackSuccess, callbackError) {
                httpMethod('put', httpFragment, callbackSuccess, callbackError,data);
            },
            get: function(httpFragment, callbackSuccess, callbackError) {
                httpMethod('get', httpFragment, callbackSuccess, callbackError);
            },
            delete: function(httpFragment, callbackSuccess, callbackError) {
                httpMethod('delete', httpFragment, callbackSuccess, callbackError);
            }
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/aiModalService.js
// module id = 583
// module chunks = 0